import { GetToken } from '../api/common'

export const getToken = (token, tokenType) => {

    return new Promise( (resolve, reject) => {

        GetToken({
            code: token,
            type: tokenType  // 2是微信 1是Mate(Toolkit) 3是阿波罗
        }).then( (res) => {

            const statusCode = res.Code

            if (statusCode === 411 || statusCode === 401) {  // 无权限访问
                alert('未授权用户\nUnauthorized User')
                reject()
                return
            }


            if (statusCode === 403 && localStorage.AUTH_TYPE === "TOOLKIT") { // MATE端 无效token  需要退出app重新登录后才能重新进入
                alert('登录信息失效，请退出当前设备后重新登录')
                reject()
                return
            }
            if (statusCode === 421 && localStorage.AUTH_TYPE === "TOOLKIT") { // MATE端 无效token  需要退出app重新登录后才能重新进入
                alert('登录信息无效，请退出当前设备后重新登录')
                reject()
                return
            }

            if (statusCode === 421 && localStorage.AUTH_TYPE === "APOLLO") { // apollo端 无效token  需要退出app重新登录后才能重新进入
                alert('你的账号已在其他设备登录，请退出当前设备后重新登录')
                reject()
                return
            }

            if (statusCode === 200) {
                localStorage.token = res.Data.AccessToken
                localStorage.ADAccount = res.Data.ADAccount
                localStorage.EnName = res.Data.EnglishName
                localStorage.CnName = res.Data.ChineseName
                localStorage.HeadImg = res.Data.HeadImg
                localStorage.Mobile = res.Data.Mobile
                localStorage.Tier0 = res.Data.Tier0
                localStorage.Tier1 = res.Data.Tier1
                localStorage.Email = res.Data.Email
            }
            else{
                alert('statusCode:' + statusCode)
            }

            resolve()
        })
    })
}



// WEBPACK FOOTER //
// ./src/utils/getToken.js